import { Outlet, useParams, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import ProjectPhaseStepper from './ProjectPhaseStepper';
import HelpCaptureEntry from './help-capture/HelpCaptureEntry';

// Chat-only variant of ProjectLayout — the V1(c) fallback PR #1168 documented
// for T-layout-4. ProjectLayout is `min-h-screen`, so nothing above ChatPage
// had a bounded height: ChatPage's `flex-1 … overflow-hidden` wrapper grew
// with its content, the page BODY scrolled instead of `chat-scroll-area`, and
// the composer sat wherever the content ended rather than at the viewport
// bottom. Measured in real Chrome at 1536x770, document / chat-scroll-area
// scrollHeight/clientHeight: before 4488/770 with the list at 4241/4241,
// after 770/770 with the list at 4241/522.
//
// `h-screen overflow-hidden` gives the chat column a fixed height, so the
// message list is the scrolling element and the composer is pinned. Every
// other /projects/:projectId/* page keeps ProjectLayout and its body scroll
// unchanged — which is why this is a separate layout, not an edit to the
// shared one.
//
// Cost, accepted with the fallback: moving between chat and another project
// page swaps layouts, so Sidebar and the phase stepper remount there instead
// of persisting across that one navigation.
export default function ProjectChatLayout() {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) return <Navigate to="/projects" replace />;

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--bg)' }}>
      <Sidebar />
      {/* <main> sits in a row flex container, so min-h-0 has nothing to override (height is stretched, not content-sized). */}
      <main className="flex-1 flex flex-col min-w-0 min-h-0">
        <ProjectPhaseStepper projectId={projectId} />
        <Outlet />
      </main>
      {/* Same entry point ProjectLayout mounts — see HelpCaptureEntry.tsx.
          On chat it is lifted above the composer via the
          --chat-bottom-stack-height variable ChatPage publishes. */}
      <HelpCaptureEntry projectId={projectId} />
    </div>
  );
}
